import { SWITCH_DUAL_LANGUAGE_GRADE } from '../actionTypes/shared/apiActionTypes';

export const initialState = {
    selectedGrade: null,
};

export const reducer = (state = initialState, action = {}) => {
    if (action.type === SWITCH_DUAL_LANGUAGE_GRADE) {
        return {
            ...state,
            selectedGrade: action.selectedGrade,
        };
    }
    return state;
};

const getSelectedDualLanguageGrade = state => state.selectedGrade;

export const selectors = {
    getSelectedDualLanguageGrade,
};
